const getPercentage = (price: number, originalPrice: number) =>
    Math.ceil(((originalPrice - price) / originalPrice) * 100);

export default getPercentage;
